<template>
  <div class="content-tab lldpremote">
    <div class="content-body">
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <div class="group-table" v-if="ports && ports.length > 0">
        <fixed-table ref="groupTable" :data="ports" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column :id="$t('acl.port')" :title="this.$isOverflow($t('acl.port'))" style="width: 10%;">{{$t('acl.port')}}</column>
              <column :id="$t('lldp.chassisId')" :title="this.$isOverflow($t('lldp.chassisId'))" style="width: 15%;">{{$t('lldp.chassisId')}}</column>
              <column :id="$t('lldp.neighborId')" :title="this.$isOverflow($t('lldp.neighborId'))" style="width: 15%;">{{$t('lldp.neighborId')}}</column>
              <column :id="$t('lldp.systemName')" :title="this.$isOverflow($t('lldp.systemName'))" style="width: 20%;">{{$t('lldp.systemName')}}</column>
              <column :id="$t('lldp.systemCpa')" :title="this.$isOverflow($t('lldp.systemCpa'))" style="width: 20%;">{{$t('lldp.systemCapa')}}</column>
              <column :id="$t('lldp.managementAddress')" :title="this.$isOverflow($t('lldp.managementAddress'))" style="width: 20%;">{{$t('lldp.managementAddress')}}</column>
            </div>
            <template slot="rows" slot-scope="props">
                <div class="link-row">
                    <row class="right" :props="props">
                      <div class="data" style="width: 10%;" :title="props.data.key">{{props.data.key}}</div>
                      <div class="data" style="width: 15%;" :title="props.data.val.ChassisId">{{props.data.val.ChassisId}}
                      </div>
                      <div class="data" style="width: 15%;" :title="props.data.val.PortId">{{props.data.val.PortId}}
                      </div>
                      <div class="data" style="width: 20%;" :title="props.data.val.SystemName">{{props.data.val.SystemName}}
                      </div>
                      <div class="data" style="width: 20%;" :title="getCapability(props.data.val.SystemCapabilities)">{{getCapability(props.data.val.SystemCapabilities)}}
                      </div>
                      <div class="data" style="width: 20%;" :title="(props.data.val.ManagementAddress) ? props.data.val.ManagementAddress : '--'">{{(props.data.val.ManagementAddress) ? props.data.val.ManagementAddress : '--'}}
                      </div>
                    </row>
                </div>
            </template>
        </fixed-table>
      </div>
      <div class="formRow" v-else>
        <nodata/>
        <div>{{$t('empty')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import nodata from '../assets/svg/no_data.svg'
export default {
  name: 'LldpRemote',
  components: {
    fixedTable,
    row,
    column,
    nodata
  },
  data () {
    return {
      isShowLoading: false,
      ports: [],
      dataInterval: null
    }
  },
  created: async function () {
    this.getData()
    let me = this
    window.addEventListener('resize', this.myEventHandler)
    setTimeout(() => {
      me.$forceUpdate()
    }, 500)
  },
  beforeDestroy () {
    clearInterval(this.dataInterval)
    this.dataInterval = null
  },
  watch: {
    currentUser: {
      handler (value) {
        if (!value) {
          this.$store.commit('updateGetDeviceData', false)
          clearInterval(this.dataInterval)
          this.dataInterval = null
          this.onClose()
        }
      },
      immediate: true,
      deep: true
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.dataInterval)
        this.dataInterval = null
      }
    },
    lang: {
      handler (value) {
        let me = this
        setTimeout(() => {
          me.$forceUpdate()
        }, 500)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['getLLDPNeighbors']),
    getData: function () {
      this.isShowLoading = true
      this.getLLDPNeighbors()
        .then((res) => {
          if (res && res.error_code === 200) {
            let temp = res.result
            if (temp) {
              temp.sort(function (a, b) {
                return Number(a.key) - Number(b.key)
              })
            }
            this.ports = temp
            this.isShowLoading = false
          }
        })
      this.dataInterval = setInterval(() => {
        this.getLLDPNeighbors()
          .then((res) => {
            if (res && res.error_code === 200) {
              let temp = res.result
              if (temp) {
                temp.sort(function (a, b) {
                  return Number(a.key) - Number(b.key)
                })
              }
              this.ports = temp
            }
          })
      }, this.intervalTime)
    },
    getCapability: function (item) {
      let result = ''
      let resultOArray = []
      let _2Item = item.toString(2)
      _2Item = _2Item.split('')
      _2Item.reverse()
      _2Item.forEach((element, index) => {
        if (parseInt(element)) {
          switch (index) {
            case 0:
              resultOArray.push(this.$t('remoteDevice.other'))
              break
            case 1:
              resultOArray.push(this.$t('remoteDevice.repeater'))
              break
            case 2:
              resultOArray.push(this.$t('remoteDevice.bridge'))
              break
            case 3:
              resultOArray.push(this.$t('remoteDevice.WLAN'))
              break
            case 4:
              resultOArray.push(this.$t('remoteDevice.router'))
              break
            case 5:
              resultOArray.push(this.$t('remoteDevice.telephone'))
              break
            case 6:
              resultOArray.push(this.$t('remoteDevice.cable'))
              break
            case 7:
              resultOArray.push(this.$t('remoteDevice.station'))
              break
            case 8:
              resultOArray.push(this.$t('remoteDevice.reserved'))
              break
          }
        }
      })
      if (resultOArray.length > 1) {
        resultOArray.forEach((element, idx) => {
          if (resultOArray.length - 1 === idx) {
            result = result + element
          } else {
            result = result + element + ','
          }
        })
      } else {
        result = result + resultOArray[0]
      }
      return result
    },
    myEventHandler (e) {
      this.$forceUpdate()
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      portNumber: state => state.module.portNum,
      showQuickHelp: state => state.app.showQuickHelp,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      currentUser: state => state.module.currentUser,
      showFullLoading: state => state.module.showFullLoading,
      intervalTime: state => state.app.intervalTime
    })
  }
}
</script>

<style lang="scss" scoped>

.lldpremote {
  position: relative;
  padding: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .formRow {
    text-align: center;
    svg {
      width: 190px;
      height: 190px;
    }
    div {
      font-family: 'Roboto-M' !important;
      font-size: 16px;
    }
  }
  .group-table {
    height: 100%;
    .header {
      padding-left: 0px;
      .qweb-column-title {
        position: relative;
      }
    }
    .qweb-column, .data {
      text-overflow: ellipsis;
      /* Required for text-overflow to do anything */
      white-space: nowrap;
      overflow: hidden;
      padding-left: 8px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LldpRemote.vue